import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Button, Space, Typography, Tooltip } from 'antd';

import Flags from '../Flags';
import { getLanguages } from '../../misc/requests';

import './LanguageSwitcher.scss';

const { Text } = Typography;

const LanguageLabel = ({ language }) => (
  <div className="language-label">
    <Tooltip title={`${language.name} (${language.code.toUpperCase()})`} placement="left">
      <div className="language-label-flag">{Flags[language.code] || Flags['en']}</div>
    </Tooltip>
    <div className="language-label-text">{language.name}</div>
  </div>
);

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [languages, setLanguages] = useState([]);

  const handleLanguageChange = useCallback(
    (langKey) => {
      i18n.changeLanguage(langKey);
    },
    [i18n]
  );

  let currentLanguage = languages.find((lang) => lang.key === i18n.language);
  if (currentLanguage == null) {
    currentLanguage = {
      key: 'en',
      label: <LanguageLabel language={{ code: 'en', name: 'English', flag: '🇬🇧' }} />,
      onClick: () => handleLanguageChange('en'),
    };
  }

  useEffect(() => {
    getLanguages().then((fetchedLanguages) => {
      const menuItems = fetchedLanguages.map((language) => ({
        key: language.code,
        label: <LanguageLabel language={language} />,
        onClick: () => handleLanguageChange(language.code),
      }));
      setLanguages(menuItems);
    });
  }, [handleLanguageChange]);

  if (languages.length === 0) {
    return null; // Don't show language dropdown if no languages are active
  }

  return (
    <Dropdown
      menu={{ items: languages }}
      trigger={['click']}
      placement="bottomRight"
      classNames={{ root: 'language-switcher-dropdown' }}
    >
      <Button type="text" className="language-switcher-button">
        <Space>
          <Text>{currentLanguage.label}</Text>
          <span className="language-switcher-arrow" />
        </Space>
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;
